import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FeedRequest, FeedsSortConfiguration } from '../feeds.config';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FilterFieldsConfig1 } from './request.config';
import { FeedsService } from '../../../service/feeds/feeds.service';
import { RequestSideNavComponent } from './request-side-nav/request-side-nav.component';
import { SdsFormlyTypes } from '@gsa-sam/sam-formly';
import { AuthService } from '@gsa-sam/shared';

@Component({
  selector: 'sam-frontend-admin-request-feeds',
  templateUrl: './request-feeds.component.html',
  styleUrls: ['./request-feeds.component.css'],
})
export class RequestFeedsComponent implements OnInit, AfterViewChecked {
  fields1: FormlyFieldConfig[] = FilterFieldsConfig1;
  filterObject: any = {};

  isMobileResolution: boolean;
  page = {
    pageNumber: 1,
    pageSize: 25,
    totalPages: 0,
  };

  cookie: any;

  top = { id: 'top' };
  bottom = { id: 'bottom' };
  initLoad: boolean;
  totalRecords: number;
  totalPages: any = 0;
  loading = new Array(25);
  SortConfiguration = FeedsSortConfiguration;
  selectedSort: any = this.SortConfiguration[0];

  pageNum: number = 1;
  requestData: FeedRequest[] = [];
  @ViewChild('requestSideNav') requestSideNav: RequestSideNavComponent;

  constructor(
    private feedsService: FeedsService,
    private changeDetectionRef: ChangeDetectorRef,
    
    private authXService: AuthService
  ) { }

  ngOnInit(): void {
    // this is the X-Auth was this.iamService.auth.token
    this.cookie = this.authXService.authToken();

    this.toggleResolution();
    this.loadRequestData();

  }

  ngAfterViewChecked() {
    this.changeDetectionRef.detectChanges();
  }

  /**
   * @name - onResize
   * @type Event - triggered by when the document view (window) has been resized
   * @param event - add event listner method allows to handle event of the host element in the directive class
   */
  @HostListener('window:resize')
  onResize() {
    this.toggleResolution();
  }

  /**
   * @name toggleResolution
   * @description Sets isMobileResolution flag on page load and resize.
   *              Called by ngInit() and HostListener(window:resize)
   */
  toggleResolution(): void {
    this.isMobileResolution = window.innerWidth <= 639;
  }

  /**
* @name redirectToView
* @type function
* @param url - url of link to open
* @description opens new tab to the URL supplied
*/
  public redirectToView(url: string): void {
    window.open(url, '_self');
  }

  /**
   * @name onPageNumChange
   * @type Event - triggered by Pagination component's pageChange event
   * @param event - Event that contains the following
   *                totalPages: total number of pages to display
   *                pageNumber: the current page number
   *                pageSize: the amount of records to display (handled by pagination dropdown)
   */
  onPageNumChange(event: any) {
    this.page.pageSize = event.pageSize;
    this.pageNum = event.pageNumber;
    this.loadRequestData();
  }

  /**
   * @name loadRequestData
   * @param event - Event that contains the
   * request data
   */

  loadRequestData() {
    this.initLoad = true;
    let avlOptions = [];
    const payload = {
      Cookie: this.cookie,
      pgNum: this.pageNum,
      sortBy: this.selectedSort.field,
      order: this.selectedSort.direction,
      limit: this.page.pageSize,
      skip: '',
      feedTypeId: this.filterObject?.feedTypeId || '1,2',
      reqIds: this.filterObject.reqTypeIds,
      statIds: this.filterObject.reqStatusIds,
      keyword: this.filterObject.keyword,
      requestedBy: this.filterObject.reqByQuery,
      respondedBy: this.filterObject.resByQuery,
      agencyPicker: this.filterObject.agencyPicker
    };
    const checkAndDiableOrEnableRequestDomain = this.requestSideNav?.checkAndDiableOrEnableRequestDomain || null;

    payload['domainIds'] = this.checkreqByDomain();
    this.feedsService
      .getRequestData(payload)
      .subscribe((jsonData) => {

        this.requestData = jsonData?.requestFeeds || [];
        this.totalRecords = jsonData?.totalRecords || 0;
        const requestTypeMap = jsonData?.requestTypeMap || {};
        this.page.totalPages = Math.ceil(this.totalRecords / this.page.pageSize);
        for (let value in requestTypeMap) {
          if (+value && requestTypeMap[value] > 0) { avlOptions.push(value); }
        }

        this.initLoad = false;
        if (!this.filterObject.reqTypeIds) {
          localStorage.setItem('filters', JSON.stringify(avlOptions));
        }
        let domainKeys = Object.keys(jsonData.domainMap);
        if(domainKeys.includes('14'||'18'))domainKeys.push('18,14');
        if(domainKeys.includes('15'||'19'))domainKeys.push('19,15');
        avlOptions = JSON.parse(localStorage.getItem('filters'));
        domainKeys = domainKeys.filter((v,i,a)=>a.indexOf(v)==i);
        this.updateFilterListOptions(avlOptions);
        if (checkAndDiableOrEnableRequestDomain)
          checkAndDiableOrEnableRequestDomain(domainKeys);
      }, (error) => {
        this.updateFilterListOptions(avlOptions);
        if (checkAndDiableOrEnableRequestDomain)
          checkAndDiableOrEnableRequestDomain([]);
      });
  }
  checkreqByDomain() {
    const selectedIds = [];
    const reqByDomainCheckbox = this.filterObject?.reqByDomain?.reqByDomainCheckbox || false;
    const findex = this.filterObject && this.filterObject.reqTypeIds && this.filterObject.reqTypeIds ? this.filterObject.reqTypeIds.split(',').findIndex( v => v ==='1') :-1 ;
    if (findex > -1 && reqByDomainCheckbox) {
      Object.keys(reqByDomainCheckbox).forEach(
        (eachKey) => {
          if (reqByDomainCheckbox[eachKey])
            selectedIds.push('' + eachKey);
        }
      );
    }
    return selectedIds.join(',');
  }

  onFilterChange(filterObject: any) {
    this.filterObject = filterObject;
    this.pageNum = 0;
    this.page.pageNumber = 1;
    this.loadRequestData();
  }

  /**
* @name updateFilterListOptions
* @type method - called after loading
* @description - sets the Status dropdown based on available options
*/
  updateFilterListOptions(options) {
    const FilterFieldsConfig = JSON.parse(JSON.stringify(FilterFieldsConfig1));
    FilterFieldsConfig.forEach((ff) => {
      if (ff.key === 'reqType') {
        const fieldGroup = this.getFieldData(options);
        ff.fieldGroup = fieldGroup;
      }
    });

    this.fields1 = FilterFieldsConfig;
    this.changeDetectionRef.detectChanges();
  }

  getFieldData(data) {
    let fieldGroup: any = [];
    const avlOptions = [];
    const avlOptions2 = [];
    let isAvailable = true;
    data.forEach(v => {
      switch (+v) {

        case 1:
          avlOptions2.push({
            value: '1',
            label: 'Request Role'
          });
          break;
        case 9:
        case 11:
          if (isAvailable) {
            avlOptions2.unshift({
              value: '9,11',
              label: 'Invite Role'
            });
          }
          isAvailable = false;
          break;
        case 10:
          fieldGroup.push({
            key: 'acquisitionInformation',
            type: 'multicheckbox',
            defaultValue: { 10: false },
            id: '10',
            props: {
              label: 'Acquisition Information',
              selectAllOption: true,
              options: [
                {
                  value: '10',
                  label: 'Access Opportunity Attachment'
                }
              ],
            },
          })
          break;
        case 12:
          fieldGroup.push({
            key: 'entityInformation',
            type: 'multicheckbox',
            id: '12',
            defaultValue: { 12: false },
            props: {
              label: 'Entity Information',
              selectAllOption: true,
              options: [
                {
                  value: '12',
                  label: 'Register Entity'
                }
              ],
            },
          })
          break;
        case 2:
          avlOptions.push(
            {
              value: '2',
              label: 'Change Listing Title'
            })
          break;
        case 3:
          avlOptions.push({
            value: '3',
            label: 'Change Listing Number'
          })
          break;
        case 4:
          avlOptions.push(
            {
              value: '4',
              label: 'Archive Listing'
            })
          break;
        case 5:
          avlOptions.push(
            {
              value: '5',
              label: 'Unarchive Listing'
            })
          break;
        case 6:
          avlOptions.push(
            {
              value: '6',
              label: 'Change Listing Subtier'
            })
          break;
        case 7:
          avlOptions.push({
            value: '7',
            label: 'Submit Listing'
          })
          break;
        case 8:
          avlOptions.push(
            {
              value: '8',
              label: 'Publish Listing'
            })
          break;
      }

    });

    if (avlOptions.length) {
      fieldGroup.push({
        key: 'federalAssistanceInformation',
        type: 'multicheckbox',
        defaultValue: { 7: false, 8: false, 2: false, 3: false, 6: false, 4: false, 5: false },
        id: '2,3,4,5,6,7,8',
        props: {
          label: 'Federal Assistance Information',
          selectAllOption: true,
          options: avlOptions,
        },
      })
    }

    if (avlOptions2.length) {
      fieldGroup.unshift({
        key: 'administration',
        type: 'multicheckbox',
        defaultValue: { '9,11': false },
        props: {
          label: 'Administration',
          //description: 'Select any socio-economic categories which reflect the current status of your entity',
          selectAllOption: true,
          hideOptional: true,
          options: avlOptions2,
        },
      })
    }
    if(!fieldGroup.length){
      fieldGroup.push({
        type: SdsFormlyTypes.READONLY,
        props: {
          readonlyTemplate: (field) => {
            return `
              <p>No Requests</p>
            `;
          },
        },
      },)
    }
    return fieldGroup;
  }

}
